var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16675 16C5.16675 15.1716 5.83832 14.5 6.66675 14.5H25.3334C26.1618 14.5 26.8334 15.1716 26.8334 16C26.8334 16.8284 26.1618 17.5 25.3334 17.5H6.66675C5.83832 17.5 5.16675 16.8284 5.16675 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.8334C15.1716 26.8334 14.5 26.1618 14.5 25.3334L14.5 6.66671C14.5 5.83828 15.1716 5.16671 16 5.16671C16.8284 5.16671 17.5 5.83828 17.5 6.66671L17.5 25.3334C17.5 26.1618 16.8284 26.8334 16 26.8334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPlus);
export default __webpack_public_path__ + "static/media/faq_plus.d612ca71c7bc49e203800ef9599e8518.svg";
export { ForwardRef as ReactComponent };